import Decimal from 'decimal.js';

// Pure allocation math for the customer-first receipt modal. Kept free of React
// so the cheque-vs-allocated arithmetic + over-allocation guard are unit-tested
// in isolation (decimal.js avoids the 0.1 + 0.2 float drift).

// Decimal-safe sum of an { invoiceId -> amount } map.
export function totalAllocated(alloc: Record<string, number>): number {
  return Object.values(alloc)
    .reduce((s, n) => s.plus(new Decimal(n || 0)), new Decimal(0))
    .toNumber();
}

// Returns a Thai message when any positive allocation exceeds its invoice's
// outstanding balance, else null. Zero / negative rows are ignored (untouched).
export function allocationError(
  alloc: Record<string, number>,
  outstanding: Record<string, number>,
): string | null {
  for (const [id, amt] of Object.entries(alloc)) {
    if (amt <= 0) continue;
    if (new Decimal(amt).gt(new Decimal(outstanding[id] ?? 0))) {
      return `ใบ ${id} เกินยอดคงค้าง`;
    }
  }
  return null;
}
